<template>
  <div>
    <FilterToolbar
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      searchPlaceholder="Search questions & keywords..."
      @search="search"
      @update="update"
      @clear="clear">
      <facet-filter class="border-b" v-model="filters.facets.status" :filter="filterOptions.status" @input="change" />
      <facet-filter class="border-b" v-model="filters.facets.group_id" :filter="groupFilter" @input="change" />
      <facet-filter v-model="filters.facets.category_id" :filter="categoryFilter" @input="change" />
    </FilterToolbar>
  </div>
</template>

<script>
import * as filterOptions from '../../filters/assistantEntries'
import FilterToolbar from '@/components/Filters/FilterToolbar'
import FacetFilter from '@/components/Filters/FacetFilter'

export default {
  components: {
    FacetFilter,
    FilterToolbar
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      filterOptions: filterOptions
    }
  },
  computed: {
    groupFilter () {
      return filterOptions.group(this.groups)
    },
    categoryFilter () {
      return filterOptions.category(this.categories)
    }
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchQuery) {
      if (searchQuery === null || searchQuery === '') {
        this.filters.search = {}
      } else {
        this.filters.search = {
          parameter: 'search',
          query: searchQuery
        }
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    },
    groups: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
